// @flow
import { TEASER_CARDS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_TEASER_CARDS } from 'Utils/request/requestDictionary';
import { addTranslationKeys } from 'Src/i18n';

export const teaserCardsResolver = {
  name: TEASER_CARDS,
  resolve(appContext: AppContext) {
    const query = `query {
      config {
        common {
          backNavigation
          next
          previous
          scrollBackward
          scrollForward
        }
      }
    }`;
    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_COMMON_TEASER_CARDS,
        strictErrors: false,
      })
      .then(data => {
        addTranslationKeys(data.config);
        return data;
      });
  },
};
